// STRICT ROLE → DASHBOARD MAPPING
// SINGLE SOURCE OF TRUTH FOR POST-LOGIN ROUTING + ROLE GUARDS.
// NO substring matching. NO guessing. Exact role lookup only.

export const ROLE_TO_DASHBOARD = {
  platform_admin: "/platform/dashboard",
  admin: "/admin/dashboard",
  hospital_admin: "/admin/dashboard",
  doctor: "/doctor/dashboard",
  staff: "/staff/dashboard",
  reception: "/staff/dashboard",
  cashier: "/pos",
};

export function dashboardForRole(role) {
  if (!role || typeof role !== "string") return null;
  return Object.prototype.hasOwnProperty.call(ROLE_TO_DASHBOARD, role)
    ? ROLE_TO_DASHBOARD[role]
    : null;
}

// A dental clinic is its own hospital tenant, so where a user lands depends on
// the ACTIVE hospital's type as well as their role. Clinical staff go to the
// dental space; everyone else keeps their normal dashboard.
export const DENTAL_ROLE_TO_DASHBOARD = {
  admin: "/dental",
  hospital_admin: "/dental",
  doctor: "/dental",
  reception: "/dental/recalls",
  staff: "/dental/recalls",
  cashier: "/pos",
};

/**
 * Landing route for a user, given their role and the active hospital's type.
 * Falls back to the medical map for anything unmapped, so a clinic type we
 * don't know about can never strand a user on a blank page.
 */
// A physical therapy clinic is its own hospital tenant too. Clinical staff land
// on the PT board; the front desk lands where the work is for them - reception
// on the treatment floor (who is here, is there a plinth free), the cashier on
// packages and authorizations rather than the generic till.
export const PHYSIO_ROLE_TO_DASHBOARD = {
  admin: "/physio",
  hospital_admin: "/physio",
  doctor: "/physio",
  staff: "/physio/floor",
  reception: "/physio/floor",
  cashier: "/physio/balances",
};

export function dashboardFor({ role, clinicType } = {}) {
  if (!role || typeof role !== "string") return null;
  if (clinicType === "dental" &&
      Object.prototype.hasOwnProperty.call(DENTAL_ROLE_TO_DASHBOARD, role)) {
    return DENTAL_ROLE_TO_DASHBOARD[role];
  }
  if (clinicType === "physio" &&
      Object.prototype.hasOwnProperty.call(PHYSIO_ROLE_TO_DASHBOARD, role)) {
    return PHYSIO_ROLE_TO_DASHBOARD[role];
  }
  return dashboardForRole(role);
}
